package com.mshopsas.enterprise.aiw.scan.network.response

import com.mshopsas.enterprise.aiw.scan.data.basket.HistoryOrder
import kotlinx.serialization.Serializable

@Serializable
data class HistoricOrderResponse(
    val historics: List<HistoryOrder>?
)
